




import { createComponent } from '@vue/composition-api';
import contentOwnershipsMock from './mocks/contentOwnerships.js';

import { useStore } from '@/core/store';
import { useRouter } from '@/core/routes';
import libraryStore from './store';

export default createComponent({
  name: 'LibraryRoute',
  setup (props, { root }) {
    const store = useStore();
    if (!store.state.library) store.registerModule('library', libraryStore);
    store.dispatch('insertEntities', {
      name: 'ContentOwnership',
      payload: contentOwnershipsMock,
    }); // MOCK
  },
});
